// extracted by mini-css-extract-plugin
export default {"grid":"AdminList_grid__lBAJY","chip":"AdminList_chip__52ziL"};